export const countriesAlphaCode = {
  it: {
    AF: "Afghanistan",
    AX: "Isole Aland",
    AL: "Albania",
    DZ: "Algeria",
    AS: "Samoa Americane",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antartide",
    AG: "Antigua e Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Bielorussia",
    BE: "Belgio",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia-Erzegovina",
    BW: "Botswana",
    BV: "Isola di Bouvet",
    BR: "Brasile",
    IO: "Territorio britannico dell'Oceano Indiano",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambogia",
    CM: "Camerun",
    CA: "Canada",
    CV: "Capo Verde",
    KY: "Isole Cayman",
    CF: "Repubblica Centrafricana",
    TD: "Chad",
    CL: "Cile",
    CN: "Cina",
    CX: "Isola di Natale",
    CC: "Isole Cocos (Keeling)",
    CO: "Colombia",
    KM: "Comore",
    CG: "Congo",
    CD: "Congo, Repubblica Democratica",
    CK: "Isole Cook",
    CR: "Costa Rica",
    CI: "Cote D'Ivoire",
    HR: "Croazia",
    CU: "Cuba",
    CY: "Cipro",
    CZ: "Repubblica Ceca",
    DK: "Danimarca",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Repubblica Dominicana",
    EC: "Ecuador",
    EG: "Egitto",
    SV: "El Salvador",
    GQ: "Guinea Equatoriale",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Etiopia",
    FK: "Isole Falkland (Malvinas)",
    FO: "Isole Faroe",
    FJ: "Fiji",
    FI: "Finlandia",
    FR: "Francia",
    GF: "Guiana Francese",
    PF: "Polinesia Francese",
    TF: "Territori Francesi del Sud",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germania",
    GH: "Ghana",
    GI: "Gibilterra",
    GR: "Grecia",
    GL: "Groenlandia",
    GD: "Grenada",
    GP: "Guadalupa",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island & Mcdonald Islands",
    VA: "Santa Sede (Stato della Città del Vaticano)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Ungheria",
    IS: "Islanda",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Repubblica Islamica Di",
    IQ: "Iraq",
    IE: "Irlanda",
    IM: "Isola di Man",
    IL: "Israele",
    IT: "Italia",
    JM: "Giamaica",
    JP: "Giappone",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakistan",
    KE: "Kenya",
    KI: "Kiribati",
    KR: "Corea",
    KP: "Corea del Nord",
    KW: "Kuwait",
    KG: "Kirghizistan",
    LA: "Repubblica Democratica Popolare del Laos",
    LV: "Lettonia",
    LB: "Libano",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Giamahiria Araba Libica",
    LI: "Liechtenstein",
    LT: "Lituania",
    LU: "Lussemburgo",
    MO: "Macao",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malesia",
    MV: "Maldive",
    ML: "Mali",
    MT: "Malta",
    MH: "Isole Marshall",
    MQ: "Martinica",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Messico",
    FM: "Micronesia, Stati Federati di",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Marocco",
    MZ: "Mozambico",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Paesi Bassi",
    AN: "Antille Olandesi",
    NC: "Nuova Caledonia",
    NZ: "Nuova Zelanda",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Isole Marianne Settentrionali",
    NO: "Norvegia",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Territorio palestinese occupato",
    PA: "Panama",
    PG: "Papua Nuova Guinea",
    PY: "Paraguay",
    PE: "Perù",
    PH: "Filippine",
    PN: "Pitcairn",
    PL: "Polonia",
    PT: "Portogallo",
    PR: "Porto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: "Federazione Russa",
    RW: "Ruanda",
    BL: "Saint Barthelemy",
    SH: "Sant'Elena",
    KN: "Saint Kitts e Nevis",
    LC: "Santa Lucia",
    MF: "Saint Martin",
    PM: "Saint-Pierre e Miquelon",
    VC: "Saint Vincent e Grenadine",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tomé e Principe",
    SA: "Arabia Saudita",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovacchia",
    SI: "Slovenia",
    SB: "Isole Salomone",
    SO: "Somalia",
    ZA: "Sudafrica",
    GS: "Georgia del Sud e isole Sandwich",
    ES: "Spagna",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard e Jan Mayen",
    SZ: "Swaziland",
    SE: "Svezia",
    CH: "Svizzera",
    SY: "Repubblica Araba Siriana",
    TW: "Taiwan",
    TJ: "Tagikistan",
    TZ: "Tanzania",
    TH: "Thailandia",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad e Tobago",
    TN: "Tunisia",
    TR: "Turchia",
    TM: "Turkmenistan",
    TC: "Isole Turks e Caicos",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ucraina",
    AE: "Emirati Arabi Uniti",
    GB: "Regno Unito",
    US: "Stati Uniti",
    UM: "Isole periferiche degli Stati Uniti",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Vietnam",
    VG: "Isole Vergini Britanniche",
    VI: "Isole Vergini, U.S.",
    WF: "Wallis e Futuna",
    EH: "Sahara occidentale",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
  },
  en: {
    AF: "Afghanistan",
    AX: "Aland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua And Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia And Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Congo, Democratic Republic",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: 'Cote D"Ivoire',
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island & Mcdonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic Of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle Of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KR: "Korea",
    KP: "North Korea",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: 'Lao People"s Democratic Republic',
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libyan Arab Jamahiriya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States Of",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    AN: "Netherlands Antilles",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestinian Territory, Occupied",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: "Russian Federation",
    RW: "Rwanda",
    BL: "Saint Barthelemy",
    SH: "Saint Helena",
    KN: "Saint Kitts And Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin",
    PM: "Saint Pierre And Miquelon",
    VC: "Saint Vincent And Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome And Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia And Sandwich Isl.",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard And Jan Mayen",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad And Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks And Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UM: "United States Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Vietnam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis And Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
  },
}
